<template>
  <div className="demo">
    <div id="video-container" style="width: 600px"></div>
  </div>
</template>

<script>
import EZUIKit from "ezuikit-js";
export default {
  props: ["EZUIKitToken", "EZUIKitCode", "activeKey", "EZUIKitChanneln"],
  data() {
    return {
      eq_token_new: "",
      eq_code_new: "",
      eq_channeln_new: "",
      player: null,
    };
  },
  created() {
    this.eq_token_new = this.EZUIKitToken;
    this.eq_code_new = this.EZUIKitCode;
    this.eq_channeln_new = this.EZUIKitChanneln;
  },
  watch: {
    EZUIKitCode() {
      this.eq_code_new = this.EZUIKitCode;
      this.eq_channeln_new = this.EZUIKitChanneln;
      this.getCreated();
    },
    EZUIKitToken() {
      this.eq_token_new = this.EZUIKitToken;
      this.eq_channeln_new = this.EZUIKitChanneln;
      this.getCreated();
    },
    activeKey() {
      if (this.activeKey == "2") {
        this.player.stop();
      } else {
        // this.eq_token_new = this.EZUIKitToken;
        // this.eq_code_new = this.EZUIKitCode;
        // this.getCreated();
      }
    },
    dialogVisible() {
      if (!this.dialogVisible) {
        this.player.stop();
      }
    },
  },
  mounted() {
    console.group("mounted 组件挂载完毕状态===============》");
    this.getCreated();
  },
  methods: {
    getCreated() {
      let that = this;
      this.player = new EZUIKit.EZUIKitPlayer({
        id: "video-container", // 视频容器ID
        accessToken: this.eq_token_new,
        url:
          "ezopen://open.ys7.com/" +
          this.eq_code_new +
          "/" +
          this.eq_channeln_new +
          ".live",
        template: "pcLive",
        // template: 'simple', // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版; theme-可配置主题；
        plugin: ["talk"], // 加载插件，talk-对讲
        width: 600,
        height: 400,
        handleError: (err) => {
          console.log("errerr", err, that);
        },
        handleSuccess: (res) => {
          console.log("resres", res);
        },
      });
    },
  },
};
</script>
